/**
 *
 * Elem events Lifecycle events
 * @enum {string}
 * @type {Readonly<{CREATED: string, MOUNTED: string, DESTROYED: string, PROPS_CHANGE: string}>}
 */
export const ElemEvent = Object.freeze({
    CREATED: 'elem-created',
    MOUNTED: 'elem-mounted',
    DESTROYED: 'elem-destroyed',
    PROPS_CHANGE: 'props-change'
});

export const CSS_VARS_DEFAULT_PREFIX = '--w';
export const ELEM_TYPE_DOM_ATTRIBUTE_NAME = 'data-elem';
export const ELEM_ROOT_NODE_DOM_CLASS_NAME = 'elem';
export const ELEM_DOM_NODE_INSTANCE_REFERENCE_PROP = '__elem__';

export const PropsToClassMap = new Map([
    ['marginT', 'mar-top'],
    ['marginR', 'mar-right'],
    ['marginB', 'mar-bot'],
    ['marginL', 'mar-left'],
    ['paddingT', 'pad-top'],
    ['paddingR', 'pad-right'],
    ['paddingB', 'pad-bot'],
    ['paddingL', 'pad-left']
]);

export const ElemPlaceholderReasonType = {
    DATA_SOURCE: 'data-source',
    CUSTOM: 'custom'
};

export default {
    ElemEvent
};
